import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { User, Site, UserInfo, SuportSearchResult } from 'app/models/support.model';

import {environment} from '../../../environments/environment';
import {DataProvider} from '../../provider/data.provider';

import dictionary from "dict/static.json";
import { DataProvider2 } from "../../provider/data2.provider";
import { IStatResult } from "../../models/responce_result.model";

export const PromopultBalanceActionTypes = {
	INCREASE: 'increase',
	DECREASE: 'decrease',
};

interface ITariff {
	_id: string;
	weight: number;
}

interface ICtfsDetail {
	recurrentProfile: string;
	rebillStartDate: string;
	userCurrency: string;
	amount: number;
	dateTo: string;
	dateToFormatted: string;
	invoiceNumber: number;
	tariffId: string;
	tariffVariant: string;
	tariffs: ITariff[];
}

@Injectable()
export class SupportService {
	i18nTariffs: any = {
		'premium': {
			name: 'тариф «Минимальный»',
			variants: {
				'month': '1 Месяц',
				'3months': '3 Месяца',
				'6months': '6 Месяцев',
				'12months': 'Год',
				'24months': '2 года',
			},
			customDateTo: true,
			proOrder: true
		},
		'premium-2022': {
			name: 'тариф «Минимальный»',
			variants: {
				'month': '1 Месяц',
				'3months': '3 Месяца',
				'6months': '6 Месяцев',
				'12months': 'Год',
				'24months': '2 года',
			},
			customDateTo: true,
			proOrder: true
		},
		'premiumplus': {
			name: 'тариф «Базовый»',
			variants: {
				'month': '1 Месяц',
				'3months': '3 Месяца',
				'6months': '6 Месяцев',
				'12months': 'Год',
				'24months': '2 года',
			},
			customDateTo: true,
			proOrder: false
		},
		'premiumplus-2022': {
			name: 'тариф «Базовый»',
			variants: {
				'month': '1 Месяц',
				'3months': '3 Месяца',
				'6months': '6 Месяцев',
				'12months': 'Год',
				'24months': '2 года',
			},
			customDateTo: true,
			proOrder: false
		},
		'pro': {
			name: 'тариф «Про»',
			variants: {
				'month': '1 Месяц',
				'3months': '3 Месяца',
				'6months': '6 Месяцев',
				'12months': 'Год',
				'24months': '2 года',
			},
			customDateTo: true,
			proOrder: false
		},
		'pro-2022': {
			name: 'тариф «Про»',
			variants: {
				'month': '1 Месяц',
				'3months': '3 Месяца',
				'6months': '6 Месяцев',
				'12months': 'Год',
				'24months': '2 года',
			},
			customDateTo: true,
			proOrder: false
		},
		'shop': {
			name: 'тариф «Магазин»',
			variants: {
				'month': '1 Месяц',
				'3months': '3 Месяца',
				'6months': '6 Месяцев',
				'12months': 'Год',
				'24months': '2 года',
			},
			customDateTo: true,
			proOrder: true
		},
		'shop-2022': {
			name: 'тариф «Магазин»',
			variants: {
				'month': '1 Месяц',
				'3months': '3 Месяца',
				'6months': '6 Месяцев',
				'12months': 'Год',
				'24months': '2 года',
			},
			customDateTo: true,
			proOrder: true
		},
		'promo': {
			name: 'тариф «Промо»',
			variants: {
				'lifetime': 'Пожизненно',
			},
			customDateTo: false,
			proOrder: false
		},
		'municipal': {
			name: 'тариф «Муниципальный»',
			variants: {
				'lifetime': 'Пожизненно',
			},
			customDateTo: false,
			proOrder: false
		},
		'newyear2018': {
			name: 'тариф «Новогодний»',
			variants: {
				'month'    : '1 Месяц',
				'3months'  : '3 Месяца',
				'6months'  : '6 Месяцев',
				'12months' : 'Год',
				'24months' : '2 года',
			},
			customDateTo: true,
			proOrder: false
		},
		'sberbank-premium': {
			name: '[Sberbank WL] тариф «Минимальный»',
			variants: {
				'month'    : '1 Месяц',
				'3months'  : '3 Месяца',
				'6months'  : '6 Месяцев',
				'12months' : 'Год',
				'24months' : '2 года',
			},
			customDateTo: false,
			proOrder: false
		},
		'sberbank-premiumplus': {
			name: '[Sberbank WL] тариф «Базовый»',
			variants: {
				'month'    : '1 Месяц',
				'3months'  : '3 Месяца',
				'6months'  : '6 Месяцев',
				'12months' : 'Год',
				'24months' : '2 года',
			},
			customDateTo: true,
			proOrder: false,
		},
		'sberbank-pro': {
			name: '[Sberbank WL] тариф «Про»',
			variants: {
				'month'    : '1 Месяц',
				'3months'  : '3 Месяца',
				'6months'  : '6 Месяцев',
				'12months' : 'Год',
				'24months' : '2 года',
			},
			customDateTo: true,
			proOrder: false
		},
	};
	dictionary: any;
	
	public cluster: number = dictionary.config.projectId;
	
	constructor(
		public dpParent: DataProvider2,
	) {
		this.dictionary = dictionary;
	}
	
	get dp() {
		const me = this;
		
		return {
			get: function<T extends object>(endpoint: string, queryParams?): Observable<T> {
				queryParams = queryParams || {};
				queryParams['cluster'] = me.cluster;
				
				return me.dpParent.get<T>(endpoint, queryParams);
			},
			
			post: function (endpoint: string, queryParams) {
				endpoint = `${endpoint}?cluster=${me.cluster}`;
				
				return me.dpParent.post(endpoint, queryParams);
			},
			
			put: function (endpoint: string, queryParams?) {
				endpoint = `${endpoint}?cluster=${me.cluster}`;
				
				return me.dpParent.put(endpoint, queryParams);
			},
			
			delete: function (endpoint: string, queryParams?) {
				endpoint = `${endpoint}?cluster=${me.cluster}`;
				
				return me.dpParent.delete(endpoint, queryParams);
			}
		}
	};
	
	
	getSearchResult(value: string, typeFilter: string, accurateSiteSearch: boolean): Observable<SuportSearchResult> {
		return this.dp.get<SuportSearchResult>(
			'/support/negotiator/search',
			{
				value: encodeURIComponent(value),
				typeFilter, accurateSiteSearch
			}
		);
	}
	
	
	getUserInfoByID(id: string): Observable<UserInfo> {
		return this.dp.get(`/support/negotiator2/users/0000${id}`);
	}
	
	
	getSiteByID(id: string): Observable<Site> {
		return this.dp.get<Site>(`/support/negotiator2/sites/${id}`).pipe(
		map(data => {
			console.log('data', data);
			// Проверяем, что data не равен null или undefined
			if (!data) {
				return data; // возвращаем как есть (null или undefined)
			}
			
			// Проверяем существование data['pages'] и что это массив
			if (data['pages'] && Array.isArray(data['pages'])) {
				data['pageCount'] = data['pages'].filter(p => !p.match(/^_/)).length;
			} else {
				data['pageCount'] = 0;
			}
			
			return data;
		})
		);
	}	
	
	getLogs(userId: string, siteUrl: string): Observable<any[]> {
		return this.dp.get('/log', { userId, siteUrl })
			.pipe(map(r => r['stats']));
	}
	
	
	saveNote(userId: string, note: string): Observable<Object> {
		return this.dp.put(
			`/support/negotiator/users/0000${userId}/saveNote`,
			{
				userId,
				note,
				comment: '--------------'
			}
		);
	}
	
	
	getSiteLogs(siteId: string): Observable<any[]> {
		return this.dp.get('/log', { siteId })
			.pipe(map(d => d['stats']));
	}
	
	
	getSptuDetail(userId: string): Observable<any[]> {
		return this.dp.get(`/support/negotiator/users/0000${userId}/sptuDetail`);
	}
	
	
	setSptuDetail(userId: string, premiumTemplates: string[], comment: string): Observable<any> {
		return this.dp.put(
			`/support/negotiator/users/0000${userId}/sptu`,
			{ userId, comment, premiumTemplates }
		);
	}


	getSiblings(userId: string): Observable<any[]> {
		return this.dp.get(`/support/negotiator/users/${userId}/getSiblings`);
	}


	setMultilangParentId(siteId: string, multilangParentId: string, comment: string): Observable<any> {
		return this.dp.put(
			`/support/negotiator/sites/${siteId}/setMultilangParentId`,
			{ siteId, multilangParentId, comment }
		);
	}


	unsetMultilangParentId(siteId: string, comment: string): Observable<any> {
		return this.dp.put(
			`/support/negotiator/sites/${siteId}/unsetMultilangParentId`,
			{ siteId, comment }
		);
	}


	setPro(userId: string, pro: boolean, comment: string): Observable<any> {
		return this.dp.put(`/support/negotiator/users/0000${userId}/spu`, {userId, pro, comment});
	}


	changeCurrency(userId: string, currency: string, comment: string): Observable<any> {
		return this.dp.put(`/support/negotiator/users/0000${userId}/currency`, {userId, currency, comment});
	}
	
	
	restorePassword(userId: string, comment: string): Observable<any> {
		return this.dp.put(
			`/support/negotiator/users/0000${userId}/restoreUserPassword`,
			{ userId, comment }
		);
	}
	
	
	restoreSite(siteId: string, comment: string): Observable<any> {
		return this.dp.put(`/support/negotiator/sites/${siteId}/siteRestore`, {siteId, comment});
	}


	cloneSite(userId: string, siteId: string, domain: string, email: string, comment: string): Observable<any> {
		return this.dp.post(`/support/negotiator/users/0000${userId}/sites/${siteId}/clone`,
			{url: domain, email, comment});
	}
	
	
	setPassword(userId: string, password: string, comment: string): Observable<any> {
		return this.dp.put(
			`/support/negotiator/users/0000${userId}/sup`,
			{ userId, password, comment}
		);
	}
	
	
	setBan(userId: string, message: string, comment: string): Observable<any> {
		return this.dp.put(
			`/support/negotiator/users/0000${userId}/userBan`,
			{ userId, message, comment }
		)
	}
	
	
	setUnBan(userId: string, comment: string): Observable<any> {
		return this.dp.put(
			`/support/negotiator/users/0000${userId}/userUnBan`,
			{ userId, comment }
		);
	}
	
	
	setRole(userId: string, role: string, admin: boolean, accessor: boolean, comment: string): Observable<any> {
		return this.dp.put(
			`/support/negotiator/users/0000${userId}/setUserRole`,
			{ userId, role, admin, accessor, comment }
		);
	}
	
	
	setFreemiumUser(userId: string, mode: boolean, comment: string): Observable<any> {
		return this.dp.put(
			`/support/negotiator/users/0000${userId}/setFreemiumUser`,
			{ userId, mode, comment }
		);
	}
	
	
	setFreemiumSite(siteId: string, mode: boolean, comment: string): Observable<any> {
		return this.dp.put(
			`/support/negotiator/sites/${siteId}/setFreemium`,
			{ siteId, mode, comment }
		);
	}
	
	
	renewTrial(
		siteId: string,
		addDays: number,
		rtfsFilter: string,
		dateTrialStart: string,
		comment: string
	): Observable<any> {
		return this.dp.put(
			`/support/negotiator/sites/${siteId}/rtfs`,
			{
				siteId,
				addDays,
				rtfsFilter,
				dateTrialStart,
				comment
			}
		);
	}
	
	
	setSiteBlock(siteId: string, message: string, comment: string): Observable<any> {
		return this.dp.put(
			`/support/negotiator/sites/${siteId}/siteBlock`,
			{ siteId, message, comment }
		);
	}
	
	
	setSiteUnBlock(siteId: string, message: string, comment: string): Observable<any> {
		return this.dp.put(
			`/support/negotiator/sites/${siteId}/siteUnBlock`,
			{ siteId, message, comment }
		);
	}
	
	
	// deprecated
	setSiteBan(siteId: string, message: string, comment: string): Observable<any> {
		return this.dp.post(
			`/support/negotiator/sites/${siteId}/siteBan`,
			{ siteId, message, comment }
		);
	}
	
	
	banSitesByList(siteList: string[], message: string, comment: string): Observable<any> {
		return this.dp.put(`/support/negotiator/banAllSites`, { siteList, message, comment });
	}
	
	
	checkForDivly(sitesList: string[]): Observable<any> {
		return this.dp.get('/support/negotiator/checkSitesForDivly', {sitesList});
	}
	
	
	setDivlyId(userId: string, partnerId: string, comment: string): Observable<any> {
		return this.dp.put(
			`/support/negotiator/users/0000${userId}/setDivlyId`,
			{ userId, partnerId, comment }
		);
	}
	
	
	setDivlyLabel(siteId: string, action: string, comment: string): Observable<any> {
		return this.dp.put(
			`/support/negotiator/sites/${siteId}/${action}DivlyLabel`,
			{siteId, comment}
		);
	}


	setSEODivlyLabel(siteId: string, action: string, comment: string): Observable<any> {
		return this.dp.put(
			`/support/negotiator/sites/${siteId}/${action}SEODivlyLabel`,
			{siteId, comment}
		);
	}

	
	breakPublish(siteId: string, comment: string): Observable<any> {
		return this.dp.post(
			`/support/negotiator/sites/${siteId}/breakPublish`,
			{ siteId, comment }
		);
	}
	
	
	changeLang(siteId: string, userId: string, newLang: string, comment: string): Observable<any> {
		return this.dp.put(
			`/support/negotiator/sites/${siteId}/changeLang`,
			{ siteId, userId, newLang, comment }
		);
	}


	fixWidgets(siteId: string, action: string, comment: string = ''): Observable<any> {
		return this.dp.put(
			`/support/negotiator/sites/${siteId}/fixWidgets`,
			{ siteId, action, comment }
		);
	}


	// deprecated
	uberTariff(siteId: string, uberStartDate: string, userId: string, time: string, comment: string): Observable<any> {
		return this.dp.post(
			`/support/negotiator/sites/${siteId}/uber_tariff`,
			{
				siteId,
				uberStartDate,
				userId,
				page: 1,
				time,
				comment
			}
		);
	}
	
	
	getTariffs(siteId: string): Observable<any[]> {
		if (environment.SEXTANT) {
			const me = this;
			
			return new Observable(function (observer) {
				let tariffs =  [
					{
						'_idToRender': null,
						'_idEqualsTo': null,
						'extendsProcessing': [],
						'variants': [
							{
								'name': 'month',
								'amount': {
									'USD': 500,
									'RUB': 30000,
									'BRL': 1999,
									'PLN': 1950,
									'NGN': 158000
								},
								'duration': 1,
								'weight': 0,
								'predefinedDiscount': 0,
								'showMinimalAmount': true
							},
							{
								'name': '3months',
								'amount': {
									'USD': 1425,
									'RUB': 85500,
									'BRL': 5899,
									'PLN': 5558,
									'NGN': 450300
								},
								'duration': 3,
								'weight': 10,
								'predefinedDiscount': 5,
								'showMinimalAmount': true
							},
							{
								'name': '6months',
								'amount': {
									'USD': 2700,
									'RUB': 162000,
									'BRL': 9999,
									'PLN': 10530,
									'NGN': 853200
								},
								'duration': 6,
								'weight': 20,
								'predefinedDiscount': 10,
								'showMinimalAmount': true
							},
							{
								'name': '12months',
								'amount': {
									'USD': 4800,
									'RUB': 288000,
									'BRL': 18999,
									'PLN': 18720,
									'NGN': 1516800
								},
								'duration': 12,
								'weight': 30,
								'predefinedDiscount': 20,
								'showMinimalAmount': true
							},
							{
								'name': '24months',
								'amount': {
									'USD': 8400,
									'RUB': 504000,
									'BRL': 27380,
									'PLN': 32760,
									'NGN': 2654400
								},
								'duration': 24,
								'weight': 40,
								'predefinedDiscount': 30,
								'showMinimalAmount': true
							}
						],
						'isCommon': true,
						'showDateTo': true,
						'rebill': true,
						'upgradeAbility': true,
						'upgradeDateTo': false,
						'isMain': false,
						'weight': 1,
						'predefinedDiscount': 0,
						'_id': 'premium',
						'features': {
							'domainConnect': true
						},
						'amountBase': {
							'USD': 500,
							'RUB': 30000,
							'BRL': 1999,
							'PLN': 1950,
							'NGN': 158000
						},
						'__v': 0
					},
					{
						'_idToRender': null,
						'_idEqualsTo': null,
						'extendsProcessing': [],
						'variants': [
							{
								'name': 'month',
								'amount': {
									'USD': 1000,
									'RUB': 60000,
									'BRL': 3260,
									'PLN': 3900,
									'NGN': 316000
								},
								'duration': 1,
								'weight': 0,
								'predefinedDiscount': 0,
								'showMinimalAmount': true
							},
							{
								'name': '3months',
								'amount': {
									'USD': 2850,
									'RUB': 171000,
									'BRL': 9290,
									'PLN': 11115,
									'NGN': 900600
								},
								'duration': 3,
								'weight': 10,
								'predefinedDiscount': 5,
								'showMinimalAmount': true
							},
							{
								'name': '6months',
								'amount': {
									'USD': 5400,
									'RUB': 324000,
									'BRL': 17600,
									'PLN': 21060,
									'NGN': 1706400
								},
								'duration': 6,
								'weight': 20,
								'predefinedDiscount': 10,
								'showMinimalAmount': true
							},
							{
								'name': '12months',
								'amount': {
									'USD': 9600,
									'RUB': 576000,
									'BRL': 31200,
									'PLN': 37440,
									'NGN': 3033600
								},
								'duration': 12,
								'weight': 30,
								'predefinedDiscount': 20,
								'showMinimalAmount': true
							},
							{
								'name': '24months',
								'amount': {
									'USD': 16800,
									'RUB': 1008000,
									'BRL': 54800,
									'PLN': 65520,
									'NGN': 5308800
								},
								'duration': 24,
								'weight': 40,
								'predefinedDiscount': 30,
								'showMinimalAmount': true
							}
						],
						'isCommon': true,
						'showDateTo': true,
						'rebill': true,
						'upgradeAbility': true,
						'upgradeDateTo': false,
						'isMain': true,
						'weight': 2,
						'predefinedDiscount': 0,
						'_id': 'premiumplus',
						'features': {
							'domainConnect': true,
							'premiumTemplates': true,
							'goals': true,
							'supportChat': true
						},
						'amountBase': {
							'USD': 1000,
							'RUB': 60000,
							'BRL': 3260,
							'PLN': 3900,
							'NGN': 316000
						},
						'__v': 0
					}
				];
				const i18nTariffs = me.i18nTariffs;
				
				tariffs = tariffs.filter(function (tariff) {
					return tariff._id in i18nTariffs;
				});
				
				tariffs = tariffs.reduce(function (arr, tariff) {
					if (tariff._id === 'premium') {
						arr.unshift(tariff);
					} else {
						arr.push(tariff);
					}
					
					return arr;
				}, []);
				
				observer.next(tariffs);
				
				observer.complete();
			});
		}
		
		return this.dp.get(`/support/negotiator/sites/${siteId}/attsDetail`)
			.pipe(map(data => {
				let tariffs = data['tariffs'];
				const i18nTariffs = this.i18nTariffs;
				
				tariffs = tariffs.filter(tariff => tariff._id in i18nTariffs);
				
				tariffs = tariffs.reduce(function (arr, tariff) {
					if (tariff._id === 'premium') {
						arr.unshift(tariff);
					} else {
						arr.push(tariff);
					}
					
					return arr;
				}, []);
				
				return tariffs;
			}));
	}
	
	
	attachTariff(
		siteId: string,
		tariffId: string,
		variantName: string,
		customDateTo: string,
		customDaysCount: number,
		periodType: number,
		transactionId: string,
		amount: string,
		paymentType: number,
		paymentId: string,
		notFirstPayment: boolean,
		comment: string
	): Observable<any> {
		const body = {
			siteId,
			tariffId,
			variantName,
			periodType,
			transactionId,
			amount,
			paymentType,
			paymentId,
			notFirstPayment,
			comment
		};
		
		if (periodType === 1) {
			body['customDateTo'] = '';
			body['customDaysCount'] = '';
		} else if (periodType === 2) {
			body['customDateTo'] = customDateTo;
			body['customDaysCount'] = '';
		} else if (periodType === 3) {
			body['customDateTo'] = '';
			body['customDaysCount'] = customDaysCount;
		}
		
		return this.dp.post(`/support/negotiator/sites/${siteId}/atts`, body);
	}
	
	
	getChsoDetail(siteId: string): Observable<{ domains: string[], emails: string[] }> {
		return this.dp.get(`/support/negotiator/sites/${siteId}/chsoDetail`);
	}
	
	
	changeOwner(siteId: string, oldOwnerEmail: string, newOwnerEmail: string, comment: string): Observable<any> {
		return this.dp.put(
			`/support/negotiator/sites/${siteId}/chso`,
			{ siteId, oldOwnerEmail, newOwnerEmail, comment }
		);
	}
	
	
	getCtfsDetail(siteId: string, domainUrl: string): Observable<ICtfsDetail> {
		return this.dp.get(`/support/negotiator/sites/${siteId}/ctfsDetail`, { domainUrl });
	}
	
	
	changeTariff(siteId: string, tariffId: string, comment: string): Observable<any> {
		return this.dp.put(
			`/support/negotiator/sites/${siteId}/ctfs`,
			{ siteId, tariffId, comment }
		);
	}
	
	
	renewTariff(
		siteId: string,
		dateTo: string,
		periodType: number,
		customDaysCount: number,
		renewRebillDate: boolean,
		comment: string
	): Observable<any> {
		return this.dp.put(
			`/support/negotiator/sites/${siteId}/rifs`,
			{siteId, dateTo, periodType, customDaysCount, renewRebillDate, comment}
		);
	}
	
	
	getMitsDetail(siteId: string, domainUrl: string): Observable<any[]> {
		return this.dp.get(`/support/negotiator/sites/${siteId}/mitsDetail`, { domainUrl });
	}
	
	
	transferInvoice(siteId: string, userSite: string, mitsFilter: string, anotherSite: string, comment: string): Observable<any> {
		return this.dp.put(
			`/support/negotiator/sites/${siteId}/mits`,
			{ siteId, userSite, mitsFilter, anotherSite, comment }
		);
	}
	
	
	getRsaiDetail(siteId: string, domainUrl: string): Observable<any[]> {
		return this.dp.get(`/support/negotiator/sites/${siteId}/rsaiDetail`, { domainUrl });
	}
	
	
	removeInvoice(siteId: string, comment: string): Observable<any> {
		return this.dp.put(
			`/support/negotiator/sites/${siteId}/rsai`,
			{ siteId, comment }
		);
	}
	
	
	disableRecurrentProfile(siteId: string, recurrentProfile: string, comment: string): Observable<any> {
		return this.dp.put(
			`/support/negotiator/sites/${siteId}/disableRecurrentProfile`,
			{ siteId, recurrentProfile, comment }
		);
	}
	
	
	editRecurrentProfile(siteId: string, rebillStartDate: string, amount: number, comment: string): Observable<any> {
		return this.dp.put(
			`/support/negotiator/sites/${siteId}/editRecurrentProfile`,
			{ siteId, rebillStartDate, amount, comment }
		);
	}
	
	
	getSiteCategories(): any {
		return this.dp.get(`/js/admin/static/siteCategories.js`);
	}
	
	
	checkSupportEdit(siteId: string): Observable<any[]> {
		return this.dp.get('/accessor/check_support_edit', { siteId });
	}
	
	
	checkAndSaveSupportEdit(
		siteId: string,
		category: string,
		subject: string,
		defer: string,
		oldCategory: string,
		oldSubject: string,
		isSupport: boolean
	): Observable<any[]> {
		return this.dp.get(
			'/accessor/check_and_save',
			{ siteId, category, subject, defer, oldCategory, oldSubject, isSupport }
		);
	}
	
	
	getInvoiceInfo(siteId: string, invoiceNumber: string): Observable<any[]> {
		return this.dp.get(
			`/support/negotiator/sites/${siteId}/checkInvoiceNumber`,
			{ invoiceNumber }
		);
	}
	
	
	searchByEmail(email: string): Observable<SuportSearchResult> {
		return this.getSearchResult(email, 'email', true);
	}
	
	
	getSupportActionLogs(userId: string, siteUrl: string): Observable<any[]> {
		return this.dp.get('/log', { supportId: userId, siteUrl })
			.pipe(map(data => data['stats']));
	}
	
	
	getReregList(userId: string): Observable<any>  {
		return this.dp.get('/user/rereg', { userId });
	}


	getSiteFiles(siteId: string): Observable<any> {
		return this.dp.get(`/support/negotiator2/sites/${siteId}/siteFiles`);
	}


	deleteSiteFile(siteId: string, folder: string, fileName: string, comment: string): Observable<any> {
		return this.dp.delete(`/support/negotiator2/sites/${siteId}/siteFile`, {
			folder, fileName, comment,
		});
	}


	refound(siteId, data) {
		return this.dp.post(`/support/negotiator/sites/${siteId}/refound`, data);
	}


	get currencyList() { return this.dictionary.currencyList }


	getSiteHistory(siteId: string): Observable<IStatResult> {
		return this.dp.get(`/site/history/${siteId}`);
	}


	setUserHardbounce({ userId, hardbounce, comment }) {
		const
			endpointUrl = `/support/negotiator/users/0000${userId}/hardbounce`,
			data = {
				comment,
			};
		
		if (hardbounce) {
			return this.dp.put(endpointUrl, data);
		} else {
			return this.dp.delete(endpointUrl, data);
		}
	}

	setExcludeFromStats(userId, comment) {
		return this.dp.post('/support/negotiator2/exclude', { userId, comment });
	}

	/**
	 * Применить оплату к аккаунту в сервисе продвижения Promopult.
	 * Может быть больше нуля - пополнение, так и меньше - уменьшение.
	 * ВНИМАНИЕ на то, что само API принимает значение в копейках
	 * @param siteId
	 * @param {string} action Действие по изменению баланса. Можно увеличить или уменьшить
	 * @param {number} amount Сумма в рублях
	 * @param comment
	 */
	updateBalancePromopultBalance(
		siteId: string,
		action: string,
		amount: number,
		comment: string,
		supportId: string,
	) {
		if (amount === 0) {
			throw new Error('updateBalancePromopultBalance: бессмыслено менять баланс промопульта на 0 рублей!');
		}
		
		let method = '';
		if (action === PromopultBalanceActionTypes.INCREASE) {
			method = 'increaseBalance';
		} else if (action === PromopultBalanceActionTypes.DECREASE) {
			method = 'decreaseBalance';
		} else {
			throw new Error(`updateBalancePromopultBalance: неизвестный тип "${action}" изменения баланса!`);
		}
		
		return this.dp.post(
			`/support/negotiator2/sites/${siteId}/promopult/${method}`,
			{
				amount: amount * 100,
				comment,
				supportId,
			}
		);
	}
}
